module.exports = __webpack_public_path__ + "media/images/consumer/signup/payment/credit-card/diners_club-570b696b50d0b88109ea341a7befa5c7.png";